import { Button, Tooltip, ButtonProps } from "@material-ui/core";

export default function DisabledButtonWithTooltip({
  tooltipTitle,
  ...buttonProps
}: {
  tooltipTitle: string;
} & ButtonProps): JSX.Element {
  return (
    <Tooltip title={tooltipTitle}>
      <span style={{ width: "fit-content" }}>
        <Button {...buttonProps} disabled />
      </span>
    </Tooltip>
  );
}
